import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Marca } from '../../models/marca';
import { Producto } from '../../models/producto';
import { ProductoService } from '../../services/producto.service';
import { Globals } from '../../globals';
import { BuscadorService } from '../../services/buscador.service';
import { AppService } from '../../app.service';
import { Meta, Title } from '@angular/platform-browser';
import AOS from 'aos';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
	public carruselppal = [];
	public carruselCargado = false

	public galeriaCampanias: any[] = []

	public brands: Marca[];
	public banners = [];
	public bannerMid;
	public bannerTop;

	public productosPromocion: Array<Producto> = [];
	public productosIluminacionLed: Array<Producto> = [];
	public productosTuberiaYAccesorios: Array<Producto>;
	public productosCablesYAccesorios: Array<Producto>;
	public productosCableadoYFijacion: Array<Producto>;

	sedes
	ciudadActual = 'bogota'

	marcas = []
	tamGaleria = 0;

	//animaciones
	inView = 'out';
	@ViewChild('cajuela', { static: false }) animame: ElementRef;
	estaVisible: boolean = false

	//articles
	articles = []

	//sedes
	sedes_mobile = [
		{
			position: 1,
			url: '../../../assets/images/home-2023/sedes/sede-ibague.png',
			titulo_1: 'ie® Ibagué',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'ibague'
		},
		{
			position: 2,
			url: '../../../assets/images/home-2023/sedes/sede-tamana.png',
			titulo_1: 'Tamaná®',
			titulo_2: 'Oficinas administrativas Ibagué',
			ciudad: 'ibague'
		},
		{
			position: 3,
			url: '../../../assets/images/home-2023/sedes/sede-bogota.png',
			titulo_1: 'ie® Bogotá',
			titulo_2: 'Lumieléctricos',
			ciudad: 'bogota'
		},
		{
			position: 4,
			url: '../../../assets/images/home-2023/sedes/sede-nqs.png',
			titulo_1: 'NQS',
			titulo_2: 'Oficinas administrativas Bogotá',
			ciudad: 'bogota'
		},
		{
			position: 5,
			url: '../../../assets/images/home-2023/sedes/sede-panama.png',
			titulo_1: 'ie® Panamá',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'panama'
		},
		{
			position: 6,
			url: '../../../assets/images/home-2023/sedes/sede-cucuta.png',
			titulo_1: 'ie® Cúcuta',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'cucuta'
		},
		{
			position: 7,
			url: '../../../assets/images/home-2023/sedes/sede-cartagena.png',
			titulo_1: 'ie® Cartagena',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'cartagena'
		},
		{
			position: 8,
			url: '../../../assets/images/home-2023/sedes/sede-villavicencio.png',
			titulo_1: 'ie® Villavicencio',
			titulo_2: 'Lumieléctricos',
			ciudad: 'villavicencio'
		},
		{
			position: 9,
			url: '../../../assets/images/home-2023/sedes/sede-neiva.png',
			titulo_1: 'ie® Neiva',
			titulo_2: 'Iluminación total',
			ciudad: 'neiva'
		},
		{
			position: 10,
			url: '../../../assets/images/home-2023/sedes/sede-cali.png',
			titulo_1: 'ie® Cali',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'cali'
		},
		{
			position: 11,
			url: '../../../assets/images/home-2023/sedes/sede-bucaramanga.png',
			titulo_1: 'ie® Bucaramanga',
			titulo_2: 'Electroindustrial',
			ciudad: 'bucaramanga'
		},
		{
			position: 12,
			url: '../../../assets/images/home-2023/sedes/sede-monteria.png',
			titulo_1: 'ie® Montería',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'monteria'
		},
		{
			position: 13,
			url: '../../../assets/images/home-2023/sedes/sede-pereira.png',
			titulo_1: 'ie® Pereira',
			titulo_2: 'Casa del bombillo 3',
			ciudad: 'pereira'
		},
		{
			position: 14,
			url: '../../../assets/images/home-2023/sedes/sede-manizales.png',
			titulo_1: 'ie® Manizales',
			titulo_2: 'Internacional de eléctricos',
			ciudad: 'manizales'
		},
		{
			position: 15,
			url: '../../../assets/images/home-2023/sedes/sede-barranquilla.png',
			titulo_1: 'ie® Barranquilla',
			titulo_2: 'Oficinas administrativas',
			ciudad: 'barranquilla'
		},
		{
			position: 16,
			url: '../../../assets/images/home-2023/sedes/sede-medellin.png',
			titulo_1: 'ie® Medellín',
			titulo_2: 'Eurocircuitos',
			ciudad: 'medellin'
		}
	]
	sedes_visibles: any[] = []

	animar_campanias: boolean = false

	 @ViewChild('uno', { static: false }) uno: ElementRef;
	 @ViewChild('dos', { static: false }) dos: ElementRef;
	 @ViewChild('tre', { static: false }) tre: ElementRef;
	 @ViewChild('cua', { static: false }) cua: ElementRef;

	constructor(
		public productoService: ProductoService,
		public http: HttpClient,
		public globals: Globals,
		public buscador: BuscadorService,
		public router: Router,
		public appService: AppService,
		private meta: Meta,
		private title: Title,
		private https: HttpClient,
		private renderer: Renderer2
	) {
		// this.getGaleriaCampanias()
		// this.creadorSedes()
		this.meta.addTags([
			{ name: 'description', content: 'Home page of SEO friendly app' },
			{ name: 'author', content: 'Jhero' },
			{ name: 'keywords', content: 'Angular, Jhero' }
		]);
		this.setTitle('IE Grupo');
		this.getMarcasActivas();

		AOS.init();
		window?.addEventListener('load', AOS.refresh)

		this.appService.compartidor.subscribe(ciudad => {
			if (ciudad) {
				this.ciudadActual = ciudad
			}
		});
		// this.getImagesArticles()
	}
	public setTitle(newTitle: string) {
		this.title.setTitle(newTitle);
	}
	ngOnInit() {
		this.sedesVisiblesMobile(1,2,9,10, 'uno')
	}

	@HostListener('document:scroll', ['$event'])
	onViewPortScroll($event) {
		if (this.animame) {
			const windowHeight = window.innerHeight; // altura de la pantalla
			const rectObjecto = this.animame.nativeElement.getBoundingClientRect();
			const topShown = rectObjecto.top >= 0;
			const bottomShown = rectObjecto.bottom <= window.innerHeight;

			this.estaVisible = topShown && bottomShown

			// console.log("estaVisible", this.estaVisible)

		}
	}

	public getCarrusel() {
		this.http.get(this.globals.urlApi + 'carruselppal').subscribe((res: any) => {
			this.carruselppal = res
			this.carruselCargado = true
		})
	}
	cargarBanners() {
		this.http.get(this.globals.urlApi + 'banner/5').subscribe((res: any) => {
			if (res) {
				this.bannerTop = res
			}
		})
		this.http.get(this.globals.urlApi + 'banner/1').subscribe((res: any) => {
			if (res) {
				this.bannerMid = res
			}
		})
	}
	public getProductosPromocion() { // estos son los de mejores precios
		this.http.get(`https://ie-vie.com:3000/api/v2/productos/promociones/${this.ciudadActual}`).subscribe((res: any) => {
			this.productosPromocion = [];
			this.productosPromocion = res.productos;
		})
	}

	// carruseles con categoria y marca
	public getProductosCategoriaMarca() {
		this.productoService.getProductosCategoriaMarca(12000000, 981, 1, 12, this.ciudadActual).subscribe(res1 => {
			this.productosIluminacionLed = res1.productos;
			this.productoService.getProductosCategoriaMarca(5000000, 25, 1, 12, this.ciudadActual).subscribe(res2 => {
				this.productosCablesYAccesorios = res2.productos
			})
		})
	}
	public getProductosTuberiaYAccesorios() {
		this.productoService.getProductosCategoria(12180000, 1, 12, this.ciudadActual).subscribe(res => {
			this.productosTuberiaYAccesorios = res.productos;
		})
	}
	public getProductosCableadoYFijacion() {
		this.productoService.getProductosCategoria(4000000, 1, 12, this.ciudadActual).subscribe(res => {
			this.productosCableadoYFijacion = res.productos;
		})
	}
	buscarPromociones() {
		this.buscador.productosPorPromocion();
		this.router.navigate(['/productos', 1, 12]);
	}
	setCiudadActual(evento) {
		this.appService.setCiudad(evento.value)
	}
	getMarcasActivas() {
		this.http.get('https://ie-vie.com:3000/api/marcas/activas').subscribe((resData: any) => {
			this.marcas = resData
			this.marcas = this.marcas.slice(0, 15)
		})
	}
	quehay(e) {
		console.log("CV", e)
	}
	getGaleriaCampanias() {
		this.http.post(`${this.globals.urlApi}galeria-campanias`, { ciudad: 'nacional' }).subscribe((resData: any[]) => {
			this.galeriaCampanias = resData;
			this.tamGaleria = this.galeriaCampanias.length;
		})
	}
	getImagesArticles(){
		this.https.get('https://ie-vie.com:3000/api/articulos/destacados').subscribe( (resData:any) => {
			if(resData.status ='ok'){
				this.articles = resData.data
				if(this.articles.length > 5){
					this.articles = this.articles.splice(0,5)
				}
			}
		});
	}
	navegarASucursal(plano_name){
		this.router.navigate([`sucursales/${plano_name}`])
	}

	
	sedesVisiblesMobile(a, b, c, d, letra){
		const collection = document.querySelectorAll<HTMLElement>('.card-mobile')
		
		for (let i = 0; i < collection.length; i++) {
			collection[i].classList.remove('animate__animated')
			collection[i].classList.remove('animate__flip')
		}
		for (let i = 0; i < collection.length; i++) {
			collection[i].classList.add('animate__animated')
			collection[i].classList.add('animate__flip')
		}
		switch(letra){
			case 'uno': {
				this.uno?.nativeElement.classList.add('vista-sedes-selected')
				this.dos?.nativeElement.classList.remove('vista-sedes-selected')
				this.tre?.nativeElement.classList.remove('vista-sedes-selected')
				this.cua?.nativeElement.classList.remove('vista-sedes-selected')
				break;
			}
			case 'dos': {
				this.uno?.nativeElement.classList.remove('vista-sedes-selected')
				this.dos?.nativeElement.classList.add('vista-sedes-selected')
				this.tre?.nativeElement.classList.remove('vista-sedes-selected')
				this.cua?.nativeElement.classList.remove('vista-sedes-selected')
				break;
			}
			case 'tre': {
				this.uno?.nativeElement.classList.remove('vista-sedes-selected')
				this.dos?.nativeElement.classList.remove('vista-sedes-selected')
				this.tre?.nativeElement.classList.add('vista-sedes-selected')
				this.cua?.nativeElement.classList.remove('vista-sedes-selected')
				break;
			}
			case 'cua': {
				this.uno?.nativeElement.classList.remove('vista-sedes-selected')
				this.dos?.nativeElement.classList.remove('vista-sedes-selected')
				this.tre?.nativeElement.classList.remove('vista-sedes-selected')
				this.cua?.nativeElement.classList.add('vista-sedes-selected')
				break;
			}
		}
		
		this.sedes_visibles = this.sedes_mobile.filter(el =>{
			if(el.position === a || el.position === b || el.position === c || el.position === d ){
				return el
			}
		})
	
	}

}
